// src/lib/pdfReport.js

import * as htmlToImage from "html-to-image";
import { downloadPdfDashboardReportApi, downloadPdfReportApi } from "./api";

function getTokenOrThrow() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("You are not logged in.");
  return token;
}

async function nodeToPngDataUrl(node) {
  if (!node) return null;

  // Higher resolution for print-like PDFs
  return await htmlToImage.toPng(node, {
    backgroundColor: "#ffffff",
    pixelRatio: 2,
    cacheBust: true,
  });
}

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
}

/**
 * meta is optional, but timeframe should be sent for Option A
 * Pass in: downloadPdfReport({ timeframe })
 */
export async function downloadPdfReport(meta = {}) {
  getTokenOrThrow();

  try {
    // 1) Grab chart DOM nodes
    const trendNode = document.getElementById("pdf-chart-trend");
    const pieNode = document.getElementById("pdf-chart-pie");
    const barNode = document.getElementById("pdf-chart-bar");

    // 2) Convert to PNG data URLs
    const [trend, pie, bar] = await Promise.all([
      nodeToPngDataUrl(trendNode),
      nodeToPngDataUrl(pieNode),
      nodeToPngDataUrl(barNode),
    ]);

    // If any chart missing, fall back to the existing GET pdf
    if (!trend || !pie || !bar) {
      const fallback = await downloadPdfReportApi();
      downloadBlob(fallback, "carbon_report.pdf");
      return;
    }

    // 3) POST to backend so ReportLab can embed these exact charts
    const payload = {
      meta,
      timeframe: meta?.timeframe || "all",
      charts: {
        trend, // data:image/png;base64,...
        pie,
        bar,
      },
    };

    const blob = await downloadPdfDashboardReportApi(payload);
    downloadBlob(blob, "carbon_report.pdf");
  } catch (error) {
    console.error("PDF download failed:", error);

    // Final fallback: existing GET PDF
    try {
      const fallback = await downloadPdfReportApi();
      downloadBlob(fallback, "carbon_report.pdf");
    } catch (e) {
      alert(error?.message || "Failed to download PDF report.");
    }
  }
}
